import { API } from "aws-amplify";

async function postDetection(
  imageURI: string,
  eventTimestamp: number,
  ordinal: number,
  workerId: number,
  asCompany?: string
): Promise<Detection> {
  try {
    const path: string = `/workers/detections` + (asCompany ? `?asCompany=${asCompany}` : "")

    const options = {
      body: {
        kvsName: "forsight_dev-dev-2108b66f-23be-49e7-b03c-68f1c28833a4",
        imageURI,
        eventTimestamp,
        ordinal,
        workerId
      }
    };

    const data = await API.post(
      'api-service',
      path,
      options
    );

    return {...data.data, direction: imageURI.includes('_in') ? "IN" : "OUT"} as Detection;
  } catch (error: any) {
    throw error;
  }
}

export default postDetection;
